import React from 'react'

/** The authoritative, fluid horizontal grid for a page in the RIGO workspace. */
export default function PageContent({ as: Component = 'main', className = '', children, ...props }) {
  return <Component
    className={`rigo-page-content min-w-0 w-full p-4 sm:p-6 ${className}`.trim()}
    data-layout="rigo-page-content"
    {...props}
  >{children}</Component>
}
